import { useAppSelector } from 'store/useAppSelector';

import {
  selectAuthAddress,
  selectAuthProvider,
  selectAuthToken,
  selectCallback,
  selectIsAPIAuthorizing,
  selectIsGithubAuth,
  selectIsGoogleAuth,
  selectIsLoggedIn,
  selectIsOAuth,
  selectIsWeb3Auth,
  selectReferralCode,
  selectWalletIcon,
  selectWalletId,
  selectWalletName,
} from '../store/selectors';
import { useSignOutMutation } from '../actions/signOut';

export const useAuth = () => {
  const [handleSignOut] = useSignOutMutation();

  const authAddress = useAppSelector(selectAuthAddress);
  const authProvider = useAppSelector(selectAuthProvider);
  const authToken = useAppSelector(selectAuthToken);
  const callback = useAppSelector(selectCallback);
  const isAPIAuthorizing = useAppSelector(selectIsAPIAuthorizing);
  const isGithubAuth = useAppSelector(selectIsGithubAuth);
  const isGoogleAuth = useAppSelector(selectIsGoogleAuth);
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const isOAuth = useAppSelector(selectIsOAuth);
  const isWeb3Auth = useAppSelector(selectIsWeb3Auth);
  const referralCode = useAppSelector(selectReferralCode);
  const walletIcon = useAppSelector(selectWalletIcon);
  const walletId = useAppSelector(selectWalletId);
  const walletName = useAppSelector(selectWalletName);

  const isLoggingIn = isAPIAuthorizing;

  return {
    authAddress,
    authProvider,
    authToken,
    callback,
    handleSignOut: handleSignOut as () => void,
    hasAuthToken: Boolean(authToken),
    isGithubAuth,
    isGoogleAuth,
    isLoggedIn,
    isLoggingIn,
    isOAuth,
    isWeb3Auth,
    referralCode,
    walletIcon,
    walletId,
    walletName,
  };
};
